import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

const initialState={
    addressList:[],
    selectedAddress: null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchAddress=createAsyncThunk('address/fetchAddress', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/address/getAddress',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchAddressById=createAsyncThunk('address/fetchAddressById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/address/getAddressById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchAdressByDeliveryId=createAsyncThunk('address/fetchAddressByDeliveryId', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/address/getAddressByDeliveryId/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createAddress=createAsyncThunk('address/createAddress', async (address)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/address/createAddress',
        {
            method:'POST',
            body: JSON.stringify(address),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})
export const updateAddress=createAsyncThunk('address/updateAddress', async ({address,cid})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/address/updateAddress/${cid}`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(address)
        }
    )
    return response.json()
})
export const deleteAddress=createAsyncThunk('address/deleteAddress', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/address/deleteAddress/${id}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const addressSlice=createSlice({
    name:'address',
    initialState,
    reducers: {
        changeRegisterStatus: (state) => {
            state.registerstatus = 'failure';
        },
        changeEditStatus: (state) => {
            state.editstatus = 'failure';
        },
        changeDeleteStatus: (state) => {
            state.deletestatus = 'failure';
        },
    },
    extraReducers:(builder)=>{
        builder
        .addCase(fetchAddress.pending, (state)=>{
            state.status='loading'
        })
        .addCase(fetchAddress.fulfilled, (state, action)=>{
            state.status='succeeded'
            state.addressList=action.payload
        })
        .addCase(fetchAddress.rejected, (state, action)=>{
            state.status='failed'
            state.error=action.error.message
        })
            .addCase(fetchAddressById.pending, (state)=>{
                state.status='loading'
            })
            .addCase(fetchAddressById.fulfilled, (state, action)=>{
                state.status='succeeded'
                state.selectedAddress=action.payload
            })
            .addCase(fetchAddressById.rejected, (state, action)=>{
                state.status='failed'
                state.error=action.error.message
            })
             .addCase(fetchAdressByDeliveryId.pending, (state)=>{
                state.status='loading'
            })
            .addCase(fetchAdressByDeliveryId.fulfilled, (state, action)=>{
                state.status='succeeded'
                state.selectedAddress=action.payload
            })
            .addCase(fetchAdressByDeliveryId.rejected, (state, action)=>{
                state.status='failed'
                state.error=action.error.message
            })
             .addCase(createAddress.pending, (state)=>{
                state.registerstatus='loading'
            })
            .addCase(createAddress.fulfilled, (state, action)=>{
                state.registerstatus='succeeded'
                state.addressList.push(action.payload)
            })
            .addCase(createAddress.rejected, (state, action)=>{
                state.registerstatus='failed'
                state.error=action.error.message
            })
             .addCase(updateAddress.pending, (state)=>{
                state.editstatus='loading'
            })
            .addCase(updateAddress.fulfilled, (state, action)=>{
                state.editstatus='succeeded'
                const index=state.addressList.findIndex(address=>address.id===action.payload.id)
                if(index!==-1){
                    state.addressList[index]=action.payload
                }
            })
            .addCase(updateAddress.rejected, (state, action)=>{
                state.editstatus='failed'
                state.error=action.error.message
            })
             .addCase(deleteAddress.pending, (state)=>{
                state.deletestatus='loading'
            })
            .addCase(deleteAddress.fulfilled, (state, action)=>{
                state.deletestatus='succeeded'
                state.addressList=state.addressList.filter(address=>address.id!==action.payload.id)
            })
            .addCase(deleteAddress.rejected, (state, action)=>{
                state.deletestatus='failed'
                state.error=action.error.message
             })
    }
})

export default addressSlice.reducer;
